import { StdResponse, request } from "@/global/config/request";
import { Cable } from "@/global/interface/device/cable";

export function getCables(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/project/${projectId}/cables`, {
        params: {
            ...params,
        }
    })
}

export function getCableDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createCable(data: Cable, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/cables`, data, {
        params: {
            ...params,
        }
    })
}

export function updateCable(id: number, data: Cable, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/cables/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteCableByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/primitives/${primitiveUuid}/delete-cable`, {
        params: {
            ...params,
        }
    })
}

export function deleteCable(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/cables/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteCables(data: number[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/cables/delete-multi`, data, {
        params: {
            ...params,
        }
    })
}

export function getCableByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/primitives/${primitiveUuid}/cables`, {
        params: {
            ...params,
        }
    })
}

export function changeCableConnect(data: Cable, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/cables/change-connect`, data, {
        params: {
            ...params,
        }
    })
}